import { DisplayOrdersPage } from '../enum';
import { isOnFreePlan } from '../../user/functions';
import { Location } from '../../location/models';
import { Account } from '../../account/models';

export function getDisplayOrdersPage({location, account}: GetDisplayOrdersPage): DisplayOrdersPage {
  return location.integrations?.squareOptions?.displayOrdersPage === DisplayOrdersPage.togo && location.displayOptions.togo && !isOnFreePlan({ location, account })
    ? DisplayOrdersPage.togo
    : DisplayOrdersPage.waitlist;
}

interface GetDisplayOrdersPage {
  location: Location;
  account: Account;
}